import { createTheme } from '@material-ui/core/styles';

import { THEME } from '../../env';
import * as linkpick from './linkpick';

const themeList = { linkpick };
const themeParams = themeList?.[THEME] || linkpick;

export const mui = createTheme(themeParams.theme);

export const params = {
  colors: themeParams?.colors,
  fontSizes2: themeParams?.fontSizes2,
  gap: themeParams?.gap,
  padding: themeParams?.padding,
  margin: themeParams?.margin,
  iconSizes: themeParams?.iconSizes,
  components: themeParams?.components,
  boxShadows: themeParams?.boxShadows,
  images: themeParams?.images,
};